export default __webpack_public_path__ + "static/SuisseIntl-Book-105e2d1d0b398e83f705b79431b934c5.woff2";